import { Fragment, useEffect, useState } from "react";
import ProjectionLoadState from "../ProjectionLoadState";
import AccordionItem from "./AccordionItem";
import CellAccordion from "./CellAccordion";
import { useDashboardUIContext } from "@contexts/dashboardUI";
import { checkIfMultipleIds, unitsIntoArray } from "@utils/checkMultipleIds";

const { useProjectContext, useProjectActions } = require("@contexts/projects")

const RenderCostCenter = ({ units }) => {
  const [isOpen, setIsOpen] = useState(true)
  const { projectionTable } = useProjectContext()

  return <>
    {checkIfMultipleIds() && <>
      <div className="wbs-accordion-divider flex gap-4" onClick={() => setIsOpen(!isOpen)}>
        <button
          className={`accordion-toggle ${isOpen ? "active" : ""}`}
        />
        <h2>{units[0].wbs_code_id_building}</h2>
      </div>
      <div className="hr-simulator" />
    </>}
    {isOpen && units.map((item, index) =>
      <AccordionItem
        item={item}
        type={"unit"}
        typeTitle={"Unidade construtiva"}
        ChildAccordionComponent={item.building_unit_name === 'ITENS SEM APROPRIAÇÃO' ? null : CellAccordion}
      />
    )
    }
    <div className="hr-simulator" />
    <AccordionItem
      item={units.reduce((acc, unit) => {
        Object.keys(unit).forEach(key => {
          if (typeof unit[key] === "number") {
            acc[key] = (acc[key] || 0) + unit[key];
          }
        });
        return acc;
      }, {})}
      type={"totals"}
      typeTitle={"Valores Totais"}
      ChildAccordionComponent={null}
    />
  </>

}

const UnitAccordion = () => {
  const { barChartDate } = useDashboardUIContext()
  const { activeProject: { _id, units }, filterDates } = useProjectContext();
  const { loadUnits } = useProjectActions();

  useEffect(() => {
    if (_id) {
      loadUnits(barChartDate);
    }
  }, [_id, filterDates, barChartDate])

  return (
    <div className="accordion margin-top-24" style={{ overflow: 'scroll', maxHeight: '70vh' }}>
      <ProjectionLoadState
        level="units"
        isMissing={!units}
        onRetry={() => loadUnits(barChartDate)}
      />
      {units && unitsIntoArray().map(i => {
        return <RenderCostCenter units={i} />
      })}
    </div>
  )
}

export default UnitAccordion;
